module.exports = __webpack_public_path__ + "03_short_brown.8bddbf68.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/03_short_brown.png
// module id = DDBx
// module chunks = 0